import React, { Component } from "react";

import {
  Modal,
  TextContainer,
  DropZone,
  BlockStack,
  Icon,
  Button,
  Text,
  DataTable,
  Spinner,
  Banner,
} from "@shopify/polaris";
import { NoteMajor } from '@shopify/polaris-icons';
import {
  reqImportKeywords,
  reqGetImportKeywordsLog,
} from "../../api";

import KeywordsResearchConvertIcon from '../../assets/KeywordsResearchConvertIcon';
import ToastFunc from "../ToastFunc";
import "./index.css";
import { API_DOMAIN } from '../../utils/constants';

//翻译包
import Language from '../../i18n/Language';
const t = Language

class ImportKeywordsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      modalActive: false,
      sheetActive: false,

      title: "",
      description: "",

      //弹窗
      showToast: false, //弹窗显示
      showToastText: "", //弹窗文字
      showToastIserror: false, //弹窗是否错误

      submitActiveLoading: false,

      files: [],
      rejectedFiles: [],
      isReq: true,

      rows: [],
      isShowError: false,
      errorTip: '',
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // 当props.open是true 请求接口
    if (nextProps.open) {
      this.setState({
        isReq: false
      })
      //如果请求过则不请求
      if (this.state.isReq) {
        this.getImportKeywordsLog()
      }
    }
  }

  // 上传
  handleSubmitAction = async () => {
    this.setState({
      submitActiveLoading: true
    });

    //是否允许替换
    var overwriteRes = 0;
    if (this.state.overwrite === true) {
      overwriteRes = 1;
    }
    const params = {
      files: this.state.imageData,
      overwriteRes: overwriteRes
    };
    const response = await reqImportKeywords(params);

    if (response.code === "200") {
      this.setState({
        files: [],
        rejectedFiles: [],
        submitActiveLoading: false
      },() => {
        this.toggleToast(t("Success"), false);
        this.getImportKeywordsLog()
      });
    } else {
      this.setState({
        submitActiveLoading: false,
        files:[],
        rejectedFiles: [],
        isShowError: true,
        errorTip: response.msg,
      }, () => {
        // this.toggleToast(response.msg, true);
      });
    }
  }

  //获取导入记录
  getImportKeywordsLog = async () => {
    this.setState({
      loading: true
    },async () => {
      const res = await reqGetImportKeywordsLog()
      if (res.code === "200") {
        let data = res.data.map((item, index) => {
          let fileName = <div style={{ width: '20rem', gap: '.5rem' }}>
            <div style={{ width: '100%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '14px' }}>{item.fileName}</div>
          </div>;
          let submitTime = item.submit_time;
          let count = item.count;
          let successCount = item.successCount;
          return ([
            fileName,
            submitTime,
            count,
            successCount,
          ]);
        })
        this.setState({
          rows: data,
          loading: false
        })
      }
    })
  }

  handleDrop = (_droppedFiles, acceptedFiles, rejectedFiles) => {
    if(acceptedFiles.length === 0) {
      this.setState({
        isShowError: true,
        errorTip: 'Accepts .xls and .csv'
      })
    } else {
      this.setState(
        {
          // files: [...this.state.files, ...acceptedFiles],  //多文件输入
          files: [ ...acceptedFiles],  //单文件
          rejectedFiles: rejectedFiles
        }, () => { this.handleDropImage() }
      );
    }
  }

  //图片数据加载
  handleDropImage = () => {
    var imageData = [];
    for (var i = 0; i < this.state.files.length; i++) {
      const filesImg = this.state.files[i];
      // 开启FileReader
      var reader = new FileReader();
      reader.readAsDataURL(filesImg); //读取文件保存在result中
      reader.onload = (e) => {
        var getRes = e.target.result;//读取的结果在result中
        imageData.push(
          {
            'name': filesImg.name,
            'image': getRes,
            'type': filesImg.type,
          }
        );
      }
    }

    this.setState({
      imageData: imageData
    });
  }

  componentDidMount() {

  }

  back = () => {// 子组件的点击事件
    this.props.changeData(!this.props.open) // 这个changeData()就是激活父组件的方法，可以传值
    this.setState({
      submitActiveLoading: false,
      rejectedFiles:[],
      files:[]
    })
  }

  //返回状态 如果提交评价 传给父组件一个状态 重新请求接口
  reRequestBack = () => {
    this.props.reRequest(true)
  }

  //提示弹窗
    toggleToast = (showToastText, showToastIserror) => {
        this.setState({
            showToast: false
        }, () => {
            this.setState(({ showToast }) => ({
                showToast: !showToast,
                showToastText: showToastText,
                showToastIserror: showToastIserror
            }));
        });
    };

  //点击联系客服
  handleContactService = ()=>{
    try {
      window.Willdesk.show()
    } catch(e) {
      this.toggleToast(t("Try again later"), true);
    }
  }

  componentWillUnmount = async () => {
    this.setState = () => false
  }

  render() {
    const {
      state: {
        showToastIserror,
        showToastText,
        submitActiveLoading,
        rows,
        loading,
        isShowError,
        errorTip,

      },
      props: { open },
      back,
      handleSubmitAction,
      getImportKeywordsLog,
    } = this;

    const toastMarkup = this.state.showToast ? (
      <ToastFunc
        content={showToastText}
        onDismiss={this.state.showToast}
        error={showToastIserror}
      />
    ) : null;

    const fileUpload = !this.state.files.length && <DropZone.FileUpload actionTitle={t("Add file")} />;

    const uploadedFiles = this.state.files.length > 0 && (
      <BlockStack>
        {this.state.files.map((file, index) => (
          <BlockStack align="center" key={index}>
            <div className="flex_layout" style={{ padding: '0.5rem 0.5rem 0.2rem' }}>
              <div><Icon source={NoteMajor} color="base" /></div>
              {file.name} 
            </div>
            <div style={{ padding: '0 0 0 2.2rem' }}><Text variant="bodySm" as="p">{file.size} {t("bytes")}</Text></div>
          </BlockStack>
        ))}
      </BlockStack>
    );

    const fileUploadLabel = <div>
      {t("Download a sample")}&nbsp;<a href={API_DOMAIN + '/export/template.csv?v=1'}>{t("CSV template")}</a> / <a href={API_DOMAIN + '/export/template.xls?v=1'}>{t("XLS template")}</a> {t("to see an example of the format required.")}
    </div>

    const pageContent =
      <Modal
        open={open}
        onClose={back}
        title={t("Import keyword - CSV / XLS")}
      >
        {
          isShowError && <Modal.Section>
            <Banner
              title={errorTip}
              tone="critical"
              action={{
                content: t("Contact us"),
                onAction: this.handleContactService
              }}
              onDismiss={() => {
                this.setState({ isShowError: false })
              }}
            >
            </Banner>
          </Modal.Section>
        }

        <Modal.Section>
          <TextContainer>
          {/* .csv,.xls,.xlsx */}
            <DropZone allowMultiple={false}  label={fileUploadLabel} accept=".xls,.csv" type="file" onDrop={this.handleDrop}> 
              {uploadedFiles}
              {fileUpload}
            </DropZone>
            <div style={{ textAlign: 'center' }}><Button variant="primary" loading={submitActiveLoading} onClick={handleSubmitAction}>{t("SUBMIT")}</Button></div>
          </TextContainer>
        </Modal.Section>
        <Modal.Section>
          <TextContainer>
            <div className="ImportTitle">
              <Text variant="headingMd" as="h2">{t("Submitted CSV / XLS")}</Text>
              <span onClick={getImportKeywordsLog}><Icon source={KeywordsResearchConvertIcon}/></span>
            </div>
            {loading ?
              <div className="DetailReport_Empty_New_div_margin">
                <Spinner size="large" color="teal" />
              </div> :
              (rows.length > 0 ?
                (rows.length > 3 ?
                  <div style={{ height: '211px', overflowY: 'auto' }}>
                    <DataTable
                      columnContentTypes={[
                        "text",
                        "text",
                        "numeric",
                        "numeric",
                      ]}
                      headings={[
                        t("CSV / XLS"),
                        t("Submitted"),
                        t("All URLs"),
                        t("Discovered URLs"),
                      ]}
                      rows={rows}
                    />
                  </div> :
                  <DataTable
                    columnContentTypes={[
                      "text",
                      "text",
                      "numeric",
                      "numeric",
                    ]}
                    headings={[
                      t("CSV / XLS"),
                      t("Submitted"),
                      t("All URLs"),
                      t("Discovered URLs"),
                    ]}
                    rows={rows}
                  />) :
                <p>{t("No upload record yet")}</p>
              )}

          </TextContainer>
        </Modal.Section>
      </Modal>;

    return (
      <div className="footerRating">
        <div className="footerRating_child">
          {pageContent}
          {toastMarkup}
        </div>
      </div>
    );
  }
}

export default ImportKeywordsModal;